// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rounded-div {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  border-radius: 10px;
  min-height: var(--height-smart-component-compact);
  container-type: inline-size;
  container-name: counter-container;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rounded-div.supervision-view {
  justify-content: center;
  container-type: normal;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  background-color: transparent;
}

.container-skill-band-data {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
}

.toggle-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  margin-top: 5px;
}

.icon-counter {
  font-size: 70px;
  margin-right: 20px;
}

.toggle-button {
  font-size: 24px;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}
.icon-and-text {
  padding: var(--padding-component);
  padding-block-end: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
}

.text {
  font-size: 16px;
  text-transform: uppercase;
}

.text.title {
  font-weight: bold;
}

.numbers-container {
  display: flex;
  margin-top: 10px;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}

.number {
  text-align: center;
}

.label {
  text-align: left;
  text-transform: uppercase;
}

.smart-general-Background {
  background: var(--smart-background, #3ea6bd);
}

.smart-label.main {
  color: var(--smart-color-main, #ffffff);
}
.smart-label.secondary {
  color: var(--smart-color-secondary, rgba(255, 255, 255, 0.7));
}

.smart-expandable-span {
  background-color: var(--smart-expandable-background, #ffffff);
  color: var(--smart-expandable-color, #3ea6bd);
}

.smart-band.double {
  background-color: var(--smart-band-double-background, rgba(255, 255, 255, 0.2));
}
.smart-band.triple {
  background-color: var(--smart-band-triple-background, rgba(255, 255, 255, 0.3));
}

.value {
  text-align: left;
}

@container counter-container (width < 400px) {
  .label {
    font-size: 10px;
  }
  .value {
    font-size: 15px;
  }
}
@container counter-container (width > 400px) {
  .label {
    font-size: 12px;
  }
  .value {
    font-size: 20px;
  }
}
.supervision-view .main-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: var(--smart-background, var(--ion-color-primary));
}
.supervision-view .icon-counter {
  font-size: 50px;
  margin-right: 0;
}
.supervision-view .text {
  word-break: break-all;
  color: black;
  font-size: 15px;
  text-transform: none;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/styles/shared-global.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;EACA,2BAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AADF;AAGE;EACE,uBAAA;EACA,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,6BAAA;AADJ;;AAMA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAMA;EACE,eAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;ECvBI,aAAA;EACA,mBAAA;EACA,SAAA;ADqBJ;ACnBI;EACI,2BAAA;EACA,iBAAA;ADqBR;AClBI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADoBR;AClBQ;EACI,gBAAA;ADoBZ;AChBI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADkBR;AAlBA;EAEE,iCAAA;EACA,oBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,sBAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,yBAAA;AAmBF;;AAhBA;EACE,iBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AAmBF;;AAhBA;EACE,kBAAA;AAmBF;;AAhBA;EACE,gBAAA;EACA,yBAAA;AAmBF;;AAhBA;EACE,4CAAA;AAmBF;;AAfE;EACE,uCAAA;AAkBJ;AAfE;EACE,6DAAA;AAiBJ;;AAbA;EACE,6DAAA;EACA,6CAAA;AAgBF;;AAZE;EACE,+EAAA;AAeJ;AAZE;EACE,+EAAA;AAcJ;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE;IACE,eAAA;EAaF;EAVA;IACE,eAAA;EAYF;AACF;AATA;EACE;IACE,eAAA;EAWF;EARA;IACE,eAAA;EAUF;AACF;AALE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;AAOJ;AAJE;EACE,eAAA;EACA,eAAA;AAMJ;AAHE;EACE,qBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAKJ","sourcesContent":["@use \"./mixins\" as *;\n\n.rounded-div {\n  --height-smart-component-compact: 158px;\n  --padding-component: 10px;\n  border-radius: 10px;\n  min-height: var(--height-smart-component-compact);\n  container-type: inline-size;\n  container-name: counter-container;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &.supervision-view {\n    justify-content: center;\n    container-type: normal;\n    --height-smart-component-compact: 70px;\n    --padding-component: 0;\n    height: fit-content;\n    width: fit-content;\n    max-width: 200px;\n    background-color: transparent;\n  }\n}\n\n\n.container-skill-band-data {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px;\n}\n\n.toggle-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 5px;\n}\n\n.icon-counter {\n  font-size: 70px;\n  margin-right: 20px;\n}\n\n.toggle-button {\n  font-size: 24px;\n}\n\n.icon-and-text {\n  @include icon-and-text;\n  padding: var(--padding-component);\n  padding-block-end: 0;\n}\n\n.text-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.text {\n  font-size: 16px;\n  text-transform: uppercase;\n}\n\n.text.title {\n  font-weight: bold;\n}\n\n.numbers-container {\n  display: flex;\n  margin-top: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 20px;\n}\n\n.number {\n  text-align: center;\n}\n\n.label {\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.smart-general-Background {\n  background: var(--smart-background, #3ea6bd);\n}\n\n.smart-label {\n  &.main {\n    color: var(--smart-color-main, #ffffff);\n  }\n\n  &.secondary {\n    color: var(--smart-color-secondary, rgb(255, 255, 255, 0.7));\n  }\n}\n\n.smart-expandable-span {\n  background-color: var(--smart-expandable-background, #ffffff);\n  color: var(--smart-expandable-color, #3ea6bd);\n}\n\n.smart-band {\n  &.double {\n    background-color: var(--smart-band-double-background, rgba(255, 255, 255, 0.2));\n  }\n\n  &.triple {\n    background-color: var(--smart-band-triple-background, rgba(255, 255, 255, 0.3));\n  }\n}\n\n.value {\n  text-align: left;\n}\n\n@container counter-container (width < 400px) {\n  .label {\n    font-size: 10px;\n  }\n\n  .value {\n    font-size: 15px;\n  }\n}\n\n@container counter-container (width > 400px) {\n  .label {\n    font-size: 12px;\n  }\n\n  .value {\n    font-size: 20px;\n  }\n\n}\n\n.supervision-view {\n  .main-icon-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    background-color: var(--smart-background, var(--ion-color-primary));\n  }\n\n  .icon-counter {\n    font-size: 50px;\n    margin-right: 0;\n  }\n\n  .text {\n    word-break: break-all;\n    color: black;\n    font-size: 15px;\n    text-transform: none;\n    font-weight: 600;\n  }\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
